import { render, staticRenderFns } from "./Baremetal.vue?vue&type=template&id=7dbc4d0e&"
import script from "./Baremetal.vue?vue&type=script&lang=js&"
export * from "./Baremetal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports